
module.config(function($stateProvider) {

    $stateProvider.state('program.admin', {
        url: '/admin',
        defaultChild: 'program.admin.issues',
        templateUrl: 'programs/admin/base',
    });


    $stateProvider.state('program.admin.scorecard', {
        templateUrl: 'programs/admin/scorecard',
        controller: 'ScorecardAdminController',
        controllerAs: 'ctrl',
    });


    $stateProvider.state('program.admin.issues', {
        templateUrl: 'programs/admin/issues',
        resolve: {
            auth: function($checkPermissions, permissions) {
                return $checkPermissions('administer', permissions);
            },
            issues: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'issues/aggregate');
            },
        },
        controller: module.cC({
            inject: ['$scope', 'program', 'issues', 'ModelService'],
            data: {
                issues: 'issues',
                showIssues: '{}',
            },
            listen: {
                program: {
                    issues: '_refreshIssues',
                },
            },
            methods: {
                rebuildIssues: function() {
                    return this.ModelService.postModelRelation(
                        this.program, 'issues/all');
                },

                _refreshIssues: function(programId) {
                    var issues = this.issues;
                    if (programId === this.program.id) {
                        this.ModelService.debouncedRelation('program', this.program.id, 'issues/aggregate')
                            .then(function(newIssues) {
                                angular.copy(newIssues, issues);
                            })
                    }
                },
            },
        }),
    });
});